import styles from "./addStaff.module.scss";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MANAGE_STAFF, RECOMMENDATIONS_TEMPLATES, STRATEGIES_TEMPLATES } from "config/paths";
import { useState } from "react";
import { ChevronRight } from "react-feather";

const ComponentTemplates = () => {
    const navigate = useNavigate();
    const [templateTypes, setTemplateTypes] = useState([{ label: "Recommendations", path: RECOMMENDATIONS_TEMPLATES }, { label: "Strategies", path: STRATEGIES_TEMPLATES }]);

    return (
        <section className={`${styles.addStaff} position-relative py-4 addManage`}>
            <Container fluid>
                <Row>
                    <Col lg="12" className="my-2">
                        <Row className="align-items-center">
                            <Col lg="5" sm="12" className="my-1">
                                <h4 style={{ fontSize: "19px" }}>Component Templates</h4>
                            </Col>
                        </Row>
                        <Row>
                            {templateTypes?.length > 0 && (
                                <Col lg="12" sm="12" className="my-2">
                                    <ul className="list-unstyled mb-0">
                                        {templateTypes.map((item, index) => (
                                            <li
                                                key={index}
                                                className="d-flex align-items-center justify-content-between py-3 px-3 border-0 rounded mb-2"
                                                style={{ backgroundColor: "#f8f9fa", cursor: "pointer" }}
                                                onClick={() => navigate(item?.path)}
                                            >
                                                <p className="mb-0" style={{ fontSize: "16px", fontWeight: "600" }}>
                                                    {item?.label}
                                                </p>
                                                <ChevronRight size={18} />
                                            </li>
                                        ))}
                                    </ul>
                                </Col>
                            )}
                        </Row>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default ComponentTemplates;
